import { render, staticRenderFns } from "./RoadshowScoreReviewSidebar.vue?vue&type=template&id=4176b6d6&scoped=true"
import script from "./RoadshowScoreReviewSidebar.vue?vue&type=script&lang=js"
export * from "./RoadshowScoreReviewSidebar.vue?vue&type=script&lang=js"
import style0 from "./RoadshowScoreReviewSidebar.vue?vue&type=style&index=0&id=4176b6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4176b6d6",
  null
  
)

export default component.exports